export default "assets/images/icons/user-940c9490.svg";